import { useEffect } from 'react';

const useTelegramInit = (): void => {
  useEffect(() => {
    if (Telegram?.WebApp) {
      Telegram.WebApp.ready();
      Telegram.WebApp.expand();
      Telegram.WebApp.disableVerticalSwipes();
      Telegram.WebApp.lockOrientation();

      if (
        Telegram.WebApp.platform == 'ios' ||
        Telegram.WebApp.platform == 'android'
      )
        Telegram.WebApp.requestFullscreen();
    }
  }, []);
};

export { useTelegramInit };
